<template>
	<div
		:class="[
			settings.classes,
			settings.gutter[gutter],
			settings.verticalGutter[verticalGutter],
			settings.alignItems[alignItems],
			settings.justifyContent[justifyContent],
		]"
	>
		<!-- @slot Only <nk-col> components should be added here -->
		<slot :gutter="gutter" :vertical-gutter="verticalGutter" />
	</div>
</template>
<script setup>
import {provide} from 'vue';
import {defineSettings} from '../composables/component';

const settings = defineSettings('NkRow');

const props = defineProps({
	gutter: {
		type: String,
		default: '3',
		required: false,
	},
	verticalGutter: {
		type: String,
		default: '0',
		required: false,
	},
	alignItems: {
		type: String,
		default: null,
		required: false,
	},
	justifyContent: {
		type: String,
		default: null,
		required: false,
	},
});

provide('gutter', props.gutter);
provide('props', props);
provide('verticalGutter', props.verticalGutter);
</script>
